import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  fetchComprobanteTypes,
  createComprobanteType,
  updateComprobanteType,
  deleteComprobanteType,
} from "../../api/accounting/comprobanteTypesApi";

export const useComprobanteTypes = () => {
  const queryClient = useQueryClient();

  const {
    data: comprobanteTypes = [],
    error,
    isLoading,
  } = useQuery({
    queryKey: ["comprobanteTypes"],
    queryFn: fetchComprobanteTypes,
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
  });

  const invalidateCache = () => {
    queryClient.invalidateQueries({ queryKey: ["comprobanteTypes"] });
  };

  const createMutation = useMutation({
    mutationFn: createComprobanteType,
    onSuccess: invalidateCache,
  });

  const updateMutation = useMutation({
    mutationFn: ({ id, data }) => updateComprobanteType(id, data),
    onSuccess: invalidateCache,
  });

  const deleteMutation = useMutation({
    mutationFn: deleteComprobanteType,
    onSuccess: invalidateCache,
  });

  return {
    comprobanteTypes,
    error,
    isLoading,
    createMutation,
    updateMutation,
    deleteMutation,
  };
};
